import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_agent/')({
  component: AgentIndexRedirect,
});

function AgentIndexRedirect() {
  return <Navigate to='/manage' />;
}
